import { render, staticRenderFns } from "./currencyField.vue?vue&type=template&id=e309424a&scoped=true&"
import script from "./currencyField.vue?vue&type=script&lang=js&"
export * from "./currencyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e309424a",
  null
  
)

export default component.exports